// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "close-3Gr7V";
var _4 = "chip-2Ea0k";
var _5 = "reasons-3B6kv";
export { _1 as "__esModule", _2 as "tablet", _3 as "close", _4 as "chip", _5 as "reasons" }
export default { "__esModule": _1, "tablet": _2, "close": _3, "chip": _4, "reasons": _5 }
